<div class="fullwidthbanner" id="home">
  <div class="ken-burns-banner">
    <ul>
      <!-- SLIDE  -->
      <li class="dark" data-transition="fade" data-slotamount="1" data-masterspeed="1500" data-delay="10000"
        data-saveperformance="off" data-title="slider 1">
        <!-- MAIN IMAGE -->
        <img [src]="images[currentIndex]" class="sepia-overlay" alt="kenburns1" data-bgposition="left center"
          data-kenburns="on" data-duration="10000" data-ease="Linear.easeNone" data-bgfit="130" data-bgfitend="100"
          data-bgpositionend="right center" />

        <div class="logo">
          <img alt="logo" src="../../../assets/img/logo1.png" />
        </div>
        <!---->

        <div class="caption customin customout tp-resizeme Ken-burns-heading font-alt" data-x="center" data-hoffset="0"
          data-y="center" data-voffset="0"
          data-customin="x:0;y:0;z:0;rotationX:90;rotationY:0;rotationZ:0;scaleX:1;scaleY:1;skewX:0;skewY:0;opacity:0;transformPerspective:200;transformOrigin:50% 0%;"
          data-customout="x:0;y:0;z:0;rotationX:0;rotationY:0;rotationZ:0;scaleX:0.75;scaleY:0.75;skewX:0;skewY:0;opacity:0;transformPerspective:600;transformOrigin:50% 50%;"
          data-speed="800" data-start="1300" data-startslide="1" data-easing="Power4.easeOut" data-endspeed="500"
          data-endeasing="Power4.easeIn">
          Gestion Administrativa
        </div>

        <div class="caption customin customout tp-resizeme" data-x="center" data-hoffset="0" data-y="center"
          data-voffset="120"
          data-customin="x:50;y:150;z:0;rotationX:0;rotationY:0;rotationZ:0;scaleX:0.5;scaleY:0.5;skewX:0;skewY:0;opacity:0;transformPerspective:0;transformOrigin:50% 50%;"
          data-customout="x:0;y:0;z:0;rotationX:0;rotationY:0;rotationZ:0;scaleX:0.75;scaleY:0.75;skewX:0;skewY:0;opacity:0;transformPerspective:600;transformOrigin:50% 50%;"
          data-speed="800" data-start="1500" data-startslide="1" data-easing="Power4.easeOut" data-endspeed="500"
          data-endeasing="Power4.easeIn">
          <div class="rev-buttons scroll-to">
            <a href="#services" class="btn btn-theme-bg btn-lg"> Ver Mas </a>
            <!--<a href="#contact" class="btn btn-lg border-color">Contactanos</a>-->
          </div>
        </div>
      </li>
      <!-- SLIDE  -->
    </ul>
  </div>
</div>
<!--full width banner-->